
define('text!presentation/settings/userVoicemail/views/userVoicemailSubscribers.html',[],function () { return '<div class="voicemail-subscribers"\n     data-bind="compose: { model: subscriberSelectionViewModel, activate: false }">\n</div>';});

